// extracted by mini-css-extract-plugin
export default {"column__text--truncate":"styles_column__text--truncate__M07f9"};